"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  loadBefore: '查看原图',
  loadStart: '加载中',
  loadEnd: '加载完成'
};
exports.default = _default;